<template>
  <v-row no-gutters>
    <v-col :align="{'center': $vuetify.breakpoint.width < 1025}" no-gutters v-if="showBtnLocation" cols="12" class="ml-md-4">
      <button class="white--text primary"
      style="padding: 4px 15px 4px 15px; border-radius: 10px;"
      @click="autoLocation()"
      > Use my current location? </button>
    </v-col>
    <v-container fluid>
      <v-row class="row1" no-gutters :class="{'justify-center': $vuetify.breakpoint.width < 1185}">
        <v-col :cols="$vuetify.breakpoint.width < 500 ? '12' : '5'">
          <vuetify-google-autocomplete
              solo
              outlined
              color="main"
              autocomplete="on"
              background-color="white"
              class="location"
              id="location"
              ref="location"
              type="address"
              :enable-geolocation="true"
              placeholder="Where is your waste?"
              v-on:placechanged="locationChange"
              @input="showBtnLocation=true"
              v-model="capturedAddress"
              country="za"
              :disabled="loading"
          >
          <template #append>
            <feather type="map-pin" :class="capturedAddress.length > 0 ? '': 'bounce'"/>
          </template>
          </vuetify-google-autocomplete>
        </v-col>
        <v-col class="col2" :cols="$vuetify.breakpoint.width < 500 ? '12': $vuetify.breakpoint.width > 500 && $vuetify.breakpoint.width < 1185 ? '1' : '3'">
          <v-btn
            class="col2-btn"
            height="56.63"
            v-on:click="proceed"
            color="primary"
        >Get quote</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="this.show" no-gutters>
        <v-col xs="16" sm="16" md="3">
          <v-text-field
          solo
          type="number"
          label="Postal Code"
          v-model="postCode"
          @change="checkPostalCode"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="font-family: Avenir1;">
          <a href="tel:+27722459777" class="primry--text head1" @click="trackPhone">072 245 9777</a>
          <h2>Book in seconds or call us for fast service </h2>
          <!--<br/>
          <h3 style="font-family: Avenir1;" class="info--text">Book any size skip, roro or truck</h3>-->
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>

import { left } from 'core-js/internals/array-reduce'
import { trackContactClick, trackEvent, trackSignupClick } from '@/utils/analytics';

export default {
  name: "Address",
  props: {
      locationChangeCallback: Function
  },
  data () {
    return {
      canProceed: false,
      location: {},
      capturedAddress: '',
      postCode: '',
      show: false,
      loading: false,
      showBtnLocation: false,
    }
  },
  methods: {
    left,
    redirect(isSignup){
      if (isSignup) {
        trackSignupClick('fast_quote_address');
      }
      window.location.href = isSignup ? 'https://app.dashwaste.co.za/signup' : 'https://app.dashwaste.co.za/login';
    },
    trackPhone(){
      trackContactClick('phone');
    },
    focusInput() {
      const locationInput = document.getElementById("location");
      if (locationInput) {
        locationInput.focus();
      } else {
        console.error("Could not find the input with ID 'location'");
      }
    },
    autoLocation(){
      //find user's location automatically
      this.canProceed = false;
      this.loading = true;
      this.capturedAddress = 'Loading ...';
      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition((location) => {
          let apikey = 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo';
          fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.coords.latitude},${location.coords.longitude}&key=${apikey}`)
          .then(response => response.json())
          .then(data => {
            // Check if the request was successful and has results
            if (data.status === 'OK' && data.results.length > 0) {
              const address = data.results[0].formatted_address;
              this.capturedAddress = address;
              this.canProceed = true;
              let postalCode = data.results[0].address_components;
              let postCode = postalCode.find((code) => code.types.includes('postal_code'));
              if(postCode){
                this.postCode = postCode.long_name;
              }
              else{
                this.show = true;
                this.loading = false;
                this.showBtnLocation = false;
              }

            } else {
              alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
              this.loading = false;
              this.showBtnLocation = false;
            }
          })
          .catch(error => {
            alert('Error fetching location');
            console.error('Error fetching address:', error);
            this.loading = false;
            this.showBtnLocation = false;
          });

        }, (error) => {
          console.log(error);
          alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
          this.$router.go();
        })
      }
      else{
        alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
        this.$router.go();
      }
    },
    locationChange(to) {
      this.canProceed = true;
      this.location = to;
      if (this.location.postal_code){
        this.show = false;
      }
      else{
        this.show = true;
      }
    },
    checkPostalCode(){
      if(this.postCode == '' || !this.postCode){
        alert('Please enter the post code for your address');
        this.canProceed = false;
      }
      else{
        this.canProceed = true;
      }
    },
    async proceed() {
      if (this.capturedAddress == '') {
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: 'Please enter your address!',
          options: {
            timeout: 3000
          }
        });
        this.canProceed = false;
        return;
      }
      if (this.capturedAddress.length < 10) {
        alert('Please enter correct address');
        this.canProceed = false;
        return;
      }
      if (this.capturedAddress.length > 5 && !this.location.postal_code && this.postCode.length != 4){
        this.canProceed = false;
        alert('Please enter correct post code for your address');
        return;
      }
      else{
        this.canProceed = true;
        trackEvent('quote_started', {
          quote_source: 'fast_quote_address',
          quote_step: 'address'
        });
        this.locationChangeCallback(this.location, this.capturedAddress, this.postCode);
      }
    }
  }
}
</script>

<style>
/** Global style for the bounce effect */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-15px);
  }
}

.bounce {
  animation: bounce 1.5s infinite;
}
</style>

<style scoped>
.links{
  font-family: Avenir2;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
}
.head1{
  font-size: 30px;
  text-decoration: none;
}
.location{
  font-size: 23px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.col2-btn{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

@media screen and (max-width: 850px){
  .row1 {
    margin-left: -50px;
  }
}

@media screen and (max-width: 500px){
  .row1{
    width: 100%;
    display: inline-block;
    margin-bottom: 1.5cm;
    margin-left: 0px;
  }
  .location{
    border-radius: 5px;
  }
  .col2{
    margin-top: -0.5cm;
  }
  .col2-btn{
    width: 100%;
    border-radius: 30px;
  }
  .col3-btn{
    width: 100%;
    border-radius: 30px;
  }

}

</style>
